import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'
import { useDispatch, useSelector } from 'react-redux'

import {
  assignedPeopleCountSelector,
  assignedUserGroupsCountSelector,
  eventTypeSelector,
  isAssignPopupSubmittingSelector,
  OPEN_ASSIGN_POPUP_SCOPES,
  openAssignPopup
} from 'features/managed_event_types'

import { AddButton } from '../../../../components'
import { AddButtonWrapper, Container } from '../styles'
import { OrganizationMemberships } from './organization_memberships'

const AddPeopleButton = (props) => (
  <AddButton {...props}>
    {I18n.t('publisher.managed_event_types.event_type.section.people.add_people')}
  </AddButton>
)

export const PeopleSection = () => {
  const dispatch = useDispatch()
  const { owning_user_group: owningUserGroup } = useSelector(eventTypeSelector)
  const userGroupsCount = useSelector(assignedUserGroupsCountSelector)
  const peopleCount = useSelector(assignedPeopleCountSelector)
  const isGroupOwned = !!owningUserGroup
  const isAssignedToOwningGroup = isGroupOwned && userGroupsCount > 0

  const openAssignMembersPopup = () => dispatch(
    openAssignPopup({
      scope: OPEN_ASSIGN_POPUP_SCOPES.people,
      userGroupId: owningUserGroup?.id
    })
  )
  const isSubmitting = useSelector(isAssignPopupSubmittingSelector)
  const headingTextColor = peopleCount === 0 ? colorTextSecondary : null

  return (
    <>
      <Container bigGaps>
        <Container smallGaps>
          <BodyText size="medium" weight="bold" color={headingTextColor}>
            {I18n.t('publisher.managed_event_types.event_type.section.people.title')}
          </BodyText>
          <BodyText size="medium" color="muted">
            {I18n.t('publisher.managed_event_types.event_type.section.people.subheader')}
          </BodyText>
        </Container>
        {peopleCount === 0 && (
          <AddPeopleButton size="small" onClick={openAssignMembersPopup} disabled={isAssignedToOwningGroup} loading={isSubmitting} />
        )}
      </Container>
      {peopleCount > 0 && (
        <div>
          <OrganizationMemberships />
          <AddButtonWrapper>
            <AddPeopleButton
              size="small"
              onClick={openAssignMembersPopup}
              loading={isSubmitting}
              disabled={isAssignedToOwningGroup}
            />
          </AddButtonWrapper>
        </div>
      )}
    </>
  )
}
